<!--英语强化课程创建/编辑-->
<template>
    <div class="app-container">
        <div class="x-nav">
            <el-breadcrumb :separator="'＞'">
                <el-breadcrumb-item @click="cancel"><a>英语强化课程</a></el-breadcrumb-item>
                <el-breadcrumb-item v-if="!courseId">新增英语强化课程</el-breadcrumb-item>
                <el-breadcrumb-item v-if="courseId">编辑英语强化课程</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-card shadow="never" style="height: calc(100vh - 160px);overflow: auto;">
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="课程名称" prop="courseName">
                            <el-input v-model="form.courseName" placeholder="最多32个字" maxlength="32" />
                        </el-form-item>
                        <el-form-item label="课程类型" prop="stageType">
                            <el-select style="width: 100%;" v-model="form.stageType" placeholder="请选择课程类型">
                                <el-option v-for="item in courseClassifyList" :key="item.dictKey" :label="item.dictValue"
                                    :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="学段" prop="periodKey">
                                    <el-select style="width: 100%;" clearable @change="changePeriod" v-model="form.periodKey"
                                        placeholder="请选择学段">
                                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                            :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="年级" prop="gradeKey">
                                    <el-select style="width: 100%;" clearable v-model="form.gradeKey" placeholder="请选择年级">
                                        <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                            :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="主讲人" prop="lecturer">
                            <choosePeople :showTitle="'选择人员'" :radio="true" ref="userId" />
                            <el-input v-model="form.lecturer" placeholder="或输入主讲人姓名" maxlength="32"
                                style="margin-top: 8px;" />
                        </el-form-item>
                        <el-form-item label="课程简介" prop="courseRecommend">
                            <el-input type="textarea" :rows="5" maxlength="1000" v-model="form.courseRecommend" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="2"></el-col>
                    <el-col :span="10" class="cover-col">
                        <el-form-item label="封面" prop="courseCover">
                            <el-upload class="avatar-uploader"
                                :action="serviceUrl+'/businessservice/famousCourse/uploadCover'"
                                :show-file-list="false" :on-success="handleAvatarSuccess" :headers="{ token }"
                                :before-upload="beforeAvatarUpload">
                                <img v-if="form.courseCover" :src="form.courseCover" class="avatar"
                                    style="position:absolute" />
                                <el-icon class="avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                    <Plus />
                                </el-icon>
                            </el-upload>
                            <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="介绍图片" prop="recommendImgList">
                            <div style="display: flex;flex-wrap:wrap;">
                                <div v-for="(item, index) in recommendImgList" :key="index" class="csbbb">
                                    <el-icon @click="delImg(index)" :size="20" class="eicon"
                                        style="cursor: pointer;z-index: 99;color: red;">
                                        <Delete />
                                    </el-icon>
                                    <img :src="item.response.data" v-if="item.response"
                                        style="width: 148px;height: 148px;margin-right: 5px;margin-bottom: 5px;">
                                </div>
                            </div>
                            <el-upload v-model:file-list="recommendImgList" :headers="{ token }" multiple
                                :show-file-list="false"
                                :action="serviceUrl+'/businessservice/famousCourse/recommendImg'"
                                :before-upload="beforeAvatarUpload" accept=".jpeg,.png,.jpg" list-type="picture-card"
                                :on-remove="handleRemove">
                                <el-icon>
                                    <Plus />
                                </el-icon>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
        <div>
            <div class="disflex-row-center cusbtbtn" :style="$store.state.zdy.isActive ? 'left:26px;' : 'left:226px;'">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { famousCourseInfo } from "@/api/admin/famousCourse"
import { stuCourseCreate, stuCourseUpdate } from "@/api/admin/stuCourse"
import { queryDict } from "@/api/admin/public";
import { serviceUrl } from "@/utils/global"

export default {
    name: "englishImproveCreate",
    components: {
    },
    data() {
        return {
            serviceUrl,
            recommendImgList: [],
            courseId: '',
            periodList: [],
            gradeList: [],
            courseClassifyList: [],
            token: this.$storage.get("token"),
            dictPromise: null,
            // 表单参数
            form: {
                courseName: '',
                courseRecommend: '',
                courseCover: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/msyk.png',
                courseType: 2,// 0-培训课程 1-名师优课 2-英语强化
                stageType: '',
                resourceType: '0',
                periodKey: '',
                gradeKey: '',
                subjectKey: '23',
                lecturer: '',
                userId: '',
                recommendImg: '',
            },
            // 表单校验
            rules: {
                courseCover: [
                    { required: true, validator: this.checkCoverValidator }
                ],
                stageType: [
                    { required: true, message: "请选择课程类型", trigger: "change" },
                ],
                resourceType: [
                    { required: true, message: "请选择资源类型", trigger: "change" },
                ],
                courseName: [
                    { required: true, message: "请输入课程名称", trigger: "blur" },
                ],
                courseRecommend: [
                    { required: true, message: "请输入课程介绍", trigger: "blur" },
                ],
                lecturer: [
                    { required: true, validator: this.checkSpeakerValidator, trigger: ["blur", "change"] },
                ]
            },
        };
    },
    created() {
        this.dictPromise = this.getQueryDict();
        this.courseId = this.$route.query.courseId || '';
        if (this.courseId) {
            this.dictPromise.then(() => {
                this.getCourseInfo();
            })
        }
    },
    activated() {
    },
    methods: {
        // 重置表单
        resetForm() {
            this.courseId = '';
            this.form = {
                courseName: '',
                courseRecommend: '',
                courseCover: '',
                courseType: 2,
                stageType: '',
                resourceType: '0',
                periodKey: '',
                gradeKey: '',
                subjectKey: '23',
                lecturer: '',
                userId: '',
                recommendImg: '',
            };
            this.recommendImgList = [];
            this.gradeList = [];
            if (this.$refs.userId) {
                this.$refs.userId.checkList = [];
            }
            if (this.$refs.form) {
                this.$refs.form.clearValidate();
            }
        },
        checkCoverValidator(rule, value, callback) {
            if (this.form.courseCover != '') {
                callback()
            } else {
                callback(new Error('请上传封面'))
            }
        },
        // 主讲人校验：选择用户或输入姓名二选一
        checkSpeakerValidator(rule, value, callback) {
            const hasUser = this.$refs.userId && this.$refs.userId.checkList.length != 0;
            if (hasUser || (this.form.lecturer && this.form.lecturer.trim() != '')) {
                callback()
            } else {
                callback(new Error('请选择或输入主讲人'))
            }
        },
        handleRemove(file, uploadFiles) {
        },
        delImg(index) {
            this.recommendImgList.splice(index, 1)
        },
        // 查询课程详情回显
        getCourseInfo() {
            famousCourseInfo({ courseId: this.courseId }).then(res => {
                const data = res.data.data;
                this.form = {
                    courseId: this.courseId,
                    courseName: data.courseName || '',
                    courseRecommend: data.courseRecommend || '',
                    courseCover: data.courseCover || '',
                    courseType: 2,
                    stageType: data.stageType || '',
                    resourceType: data.resourceType != null && data.resourceType !== '' ? String(data.resourceType) : '0',
                    periodKey: data.periodKey || '',
                    gradeKey: data.gradeKey || '',
                    subjectKey: data.subjectKey || '23',
                    lecturer: data.lecturer || '',
                    userId: data.userId || '',
                    recommendImg: data.recommendImg || '',
                };
                // 回显年级列表
                this.periodList.forEach(j => {
                    if (this.form.periodKey == j.dictKey) {
                        this.gradeList = j.childrenList;
                    }
                })
                // 回显介绍图片
                this.recommendImgList = [];
                let imgs = [];
                if (data.recommendImgList && data.recommendImgList.length > 0) {
                    imgs = data.recommendImgList;
                } else if (data.recommendImg) {
                    imgs = data.recommendImg.split(',');
                }
                imgs.forEach(e => {
                    if (e) {
                        this.recommendImgList.push({ response: { data: e } })
                    }
                })
                // 回显归属用户
                if (data.userId) {
                    this.$refs.userId.checkList = [{ userId: data.userId, trueName: data.userName }];
                }
            })
        },
        changePeriod() {
            this.form.gradeKey = '';
            this.gradeList = [];
            this.periodList.forEach(j => {
                if (this.form.periodKey == j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
        },
        getQueryDict() {
            return Promise.all([
                queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                    this.periodList = res.data.data;
                }),
                queryDict({ code: 'english_improve_classify' }).then(res => {
                    this.courseClassifyList = res.data.data;
                })
            ])
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.form.courseCover = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeAvatarUpload(rawFile) {
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        /** 提交按钮 */
        submitForm() {
            if (this.$refs.userId.checkList.length != 0) {
                this.form.userId = this.$refs.userId.checkList[0].userId;
            } else {
                this.form.userId = '';
            }
            this.$refs["form"].validate(valid => {
                if (valid) {
                    var recommendImgList = [];
                    this.recommendImgList.forEach(e => {
                        recommendImgList.push(e.response.data)
                    })
                    this.form.recommendImg = recommendImgList.toString();

                    if (this.courseId) {
                        stuCourseUpdate(this.form).then(res => {
                            if (res.data.code == 1) {
                                this.$message.success("编辑成功");
                                this.replace('/englishImprove', { isSx: 1 })
                            } else {
                                this.$message.error("操作失败")
                            }
                        })
                    } else {
                        stuCourseCreate(this.form).then(res => {
                            if (res.data.code == 1) {
                                this.$message.success("新增成功");
                                this.replace('/englishImprove', { isSx: 1 })
                            } else {
                                this.$message.error("操作失败")
                            }
                        });
                    }
                }
            });
        },
        // 取消按钮
        cancel() {
            this.replace('/englishImprove')
        },
    }
};
</script>
<style scoped>
.avatar-uploader .avatar {
    width: 270px;
    height: 152px;
    display: block;
    object-fit: cover;
}

.avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 270px;
    height: 152px;
    text-align: center;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    position: relative;
}

.csbbb .eicon {
    display: none;
    position: absolute;
    right: 20px;
    top: 5px;
    background-color: #e4e7ed;
}

.csbbb:hover .eicon {
    display: block;
}

/* 封面模块靠右，与卡片右边界保持 20px（el-card 内边距） */
.cover-col {
    display: flex;
    justify-content: flex-end;
}
</style>
